<template>
<div>
    <div class="content">
        <div class="f-grow">
            <div class="header">{{$i18n.t("text.heightManager")}}</div>
            <div class="tabs">
                <c-button :label="$i18n.t('text.singleHeight')" @click="single=!single" :showActiveState="true" :setActiveState="single"></c-button>
                <c-button :label="$i18n.t('text.interval')" @click="single=!single" :showActiveState="true" :setActiveState="!single"></c-button>
            </div>
            <a href="javascript:;" ref="height" @keydown="onKeyDown" @click="focusField('height')"><div class="height"></div><div class="f-grow field">{{ToHeight}}</div></a>
            <toggle-slide v-model="jumpOff" :labelLeft="$i18n.t('text.orderIn')" :labelRight="$i18n.t('text.jumpOff')" v-if="single"></toggle-slide>
            <a href="javascript:;" ref="from-height" @keydown="onKeyDown" @click="focusField('from-height')" v-if="!single"><div class="from-height"></div><div class="f-grow field">{{FromHeight}}</div></a>
            <a href="javascript:;" ref="interval" @keydown="onKeyDown" @click="focusField('interval')" v-if="!single"><div class="interval"></div><div class="f-grow field">{{Interval}}</div></a>           
            <div class="f-row input">
                <div class="f-column" @click="enterValue" :class="{disabled: MaxLengthReached}">  
                    <div class="f-row">
                        <div>1</div>
                        <div>2</div>
                        <div>3</div>
                    </div>
                    <div class="f-row">
                        <div>4</div>
                        <div>5</div>
                        <div>6</div>
                    </div>   
                    <div class="f-row">
                        <div>7</div>
                        <div>8</div>
                        <div>9</div> 
                        </div>  
                    <div class="f-row">  
                        <div class="zero">0</div>  
                    </div>     
                </div>
                <div class="button">
                    <div class="del" @click="backSpace"></div> 
                    <div class="return" @click="confirmValue"></div>
                </div>
            </div>
        </div>
        <div class="height-table">
            <div class="head">
                <div>#</div>
                <div>{{$t('text.height')}}</div>
                <div>{{$t('text.jumpOff')}}</div>
                <div>&nbsp;</div>
            </div>
            <div v-for="(height, i ) in heights" v-bind:key="i" :class="{zebra: i%2==0}">
                <div>{{ height.order+1 }}</div>
                <div>{{ height.value.toFixed(2) }}</div>
                <div class="icon" :class="{jumpoff: height.jumpOff}">&nbsp;</div>
                <div class="icon del" @click="deleteHeight(i)"></div>
            </div>
        </div>
    </div>
    <div class="footer-button-row">
        <c-button :label="$t('text.abort')" @click="abort"></c-button>
        <c-button :label="$t('text.save')" @click="saveHeights"></c-button>
    </div>
</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import { GUIDMixin } from '../mixin/GUIDMixin';
import navMut from '../store/mutations/navigation';
import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';

import ToggleSlide from './ToggleSlide';
import CButton from './CButton'

export default {
    name: "HeightManager",
    mixins: [GUIDMixin],
    data: function(){
        return {
            heights: null,
            entrants: null,
            focused: 'height',
            fromHeight: null,
            toHeight: null,
            interval: null,
            single: true,
            jumpOff: false,
        }
    },
    methods:{
        ...mapActions([
            glAct.SENDHEATGROUP]),
        ...mapMutations([
            navMut.SHOWNAVPOINT,
            navMut.HIDENAVPOINT]), 
        ...mapMutations([
            glMut.SETHEIGHTS]),            
        focusField(field){
            this.focused = field;
            this.$refs[field].focus();
        },
        saveHeights() {
            this.Heat.heights = this.heights;
            this.Heat.entries = this.entrants;   
            this.SETHEIGHTS({heights: this.heights, entries: this.entrants});
            this.SENDHEATGROUP();
            this.$emit('heightmanagersaved');
        },
        abort() {
            this.heights = [...this.Heat.heights]; //SHALLOW
            this.entrants = JSON.parse(JSON.stringify(this.Heat.entries)); //DEEP COPY   
            this.$emit('heightmanageraborted');
        },
        enterValue(event, directInput){
            this.focusField(this.focused);
            let val = '';
            if(directInput){
                val = event;
            }
            else{
                val = event.srcElement.innerText
            }
            if(val.length === 1 && this.focused !== null && !this.MaxLengthReached){
                if(this.focused === 'height') {
                    this.toHeight = (this.toHeight * 1000 + parseInt(val)) / 100;
                    //this.resultString = this.result.toFixed(2);
                }
                else if(this.focused === 'from-height'){
                    this.fromHeight = (this.fromHeight * 1000 + parseInt(val)) / 100;
                    //this.windString = this.toHeight.toFixed(1);

                }
                else if(this.focused === 'interval'){
                    this.interval = (this.interval * 10 + parseInt(val));

                }
            }
        },
        backSpace (event){
            this.focusField(this.focused);
            if(this.focused === 'height') {
                this.toHeight = Number.parseInt((this.toHeight * 10), 10) / 100;
                if(this.toHeight <= 0) {
                    this.toHeight = null;
                }
            }
            else if(this.focused === 'from-height'){
                this.fromHeight = Number.parseInt((this.fromHeight * 10), 10) / 100;
                if(this.fromHeight <= 0) {
                    this.fromHeight = null;
                }
            }
            else if(this.focused === 'interval'){
                this.interval = Number.parseInt((this.interval / 10), 10);
                if(this.interval <= 0) {
                    this.interval = null;
                }
            }
            
            if(event) event.stopPropagation();
            
        },
        confirmValue(event){
            this.focusField(this.focused);
            if(!!this.toHeight){
                if(this.single || !this.fromHeight || !this.interval) {
                    if(this.jumpOff || !this.heightExists(this.toHeight)){
                        this.createSingleheight(this.toHeight);
                    }
                    this.toHeight = null
                }
                else{
                    this.jumpOff = false;
                    if(this.fromHeight > this.toHeight) {
                        const help = this.fromHeight;
                        this.fromHeight = this.toHeight;
                        this.toHeight = help;
                    }
                    const steps = Number.parseInt((this.toHeight * 100 - this.fromHeight * 100) / this.interval) + 1
                    for(var i=0; i<steps; i++){
                        const newH =this.fromHeight + (this.interval / 100 * i);
                        if(!this.heightExists(newH)){
                            this.createSingleheight(newH);
                        }
                    }
                    this.toHeight = null
                    this.fromHeight = null;
                    this.interval = null;
                }
            }
            if(event) event.stopPropagation();
        },
        onKeyDown(event){
            //console.log(event);
            switch (event.keyCode) {
                case 8: //backSpace
                    this.backSpace(event);
                    break;
                case 9://TAB
                    if(!this.single)
                    {
                        switch (this.focused) {
                            case 'height':
                                this.focusField('from-height');
                                break;
                            case 'from-height':
                                this.focusField('interval');
                                break;
                            case 'interval':
                                this.focusField('height');
                                break;
                            default:
                                this.focusField('height');
                        }
                    }
                    break;
                case 13: //enter
                    this.confirmValue(event);
                    break;
                default:
                    if(event.keyCode >= 96 && event.keyCode <= 105 || event.keyCode >= 48 && event.keyCode <= 57) //number from 0-9
                        this.enterValue(event.key, true);
            }
            if(event) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        heightExists(h){
            if(!!this.heights)
                return this.heights.some(e => e.value === h);

            return false;
        },
        createSingleheight(height){
            const newHeight = {
                id: this.createGuid(),
                order: 0,
                value: height,
                jumpOff: this.jumpOff
            }

            const newResult = {
                id: this.createGuid(),
                heightId: newHeight.id,
                wind: null,
                highjumpTries: '',
                value: height,
                order: 0,
                try: 0,
            }

            if(newHeight.jumpOff || this.heights.length === 0) {
                newHeight.order = this.heights.length;
                newResult.order = newHeight.order;
                this.heights.push(newHeight);
                this.entrants.forEach(e => {
                    e.results.push(JSON.parse(JSON.stringify(newResult)));
                    newResult.id = this.createGuid();
                });
            }
            else{
                let key = this.heights.findIndex(h => h.value > height);
                let order = 0;
                if(key === -1) {
                    key = this.heights.length;
                    order = key;
                }
                else{
                    order = this.heights[key].order;
                }
                
                newHeight.order = order;
                newResult.order = order;

                if(key !== this.heights.length) {
                    for(var i=0; i<this.heights.length; i++){
                        if(this.heights[i].order >= order) {
                            this.heights[i].order++;
                            this.entrants.forEach(e => {
                                e.results[i].order++;
                            })
                        }
                    }
                }
                this.heights.splice(key, 0, newHeight);
                this.entrants.forEach(e => {
                    e.results.splice(key, 0, JSON.parse(JSON.stringify(newResult)));
                })
            }
        },
        deleteHeight(i){
            let del = true;
            if(this.entrants && this.entrants.length) {
                const found = this.entrants.some(e => {
                    if(e.results[i].highjumpTries !== '') {
                        return true;
                    }
                });
                if(found) {
                    del = confirm(this.$i18n.t('text.errorResultFound'));
                }
            }

            if(del) {
                this.heights.splice(i, 1);
                this.entrants.forEach(e => {
                    e.results.splice(i, 1);
                });
                for(var y=i; y<this.heights.length; y++){
                    this.heights[y].order-=1;
                }
            }            
        }
    },
    computed:{
        ...mapGetters(['SelectedHeat']),
        Heat: function(){
            return this.SelectedHeat;
        },
        FromHeight(){
            return this.fromHeight ? this.fromHeight.toFixed(2) : '';
        },
        ToHeight(){
            return this.toHeight ? this.toHeight.toFixed(2) : '';
        },
        Interval(){
            return this.interval ? `${this.interval}cm` : '';
        },
        MaxLengthReached(){
            if(this.focused === 'height' && this.toHeight && this.toHeight > 0.99) {
                return true;
            }
            else if(this.focused === 'from-height' && this.fromHeight && this.fromHeight > 0.99){
                return true;
            }
            else if(this.focused === 'interval' && this.interval && this.interval.toString().length === 2){
                return true;
            }
            return false;
        }
    },
    components: {
        ToggleSlide,
        CButton,
    },
    mounted(){
        this.heights = [...this.Heat.heights]; //SHALLOW
        this.entrants = JSON.parse(JSON.stringify(this.Heat.entries)); //DEEP COPY        
        this.SHOWNAVPOINT([1, 2]);
        this.$emit('heightmanagermounted');
        this.focusField('height');
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .content {
        height: calc(100% - #{$height_mid});
        overflow-x:auto;  

        > .f-grow {
            @extend %f-column;
        }

        .header {
            font-size: 16px;
            font-weight: bold;
            height: $height_default;
            line-height: $height_default;
        }

        .tabs {
            button {
                width:50%;
            }
            padding-bottom: 10px;
        }
    }

    .height-table {
        width:100%;


        div {            
            height: $height_default;  
            line-height: $height_default; 

            div {
                display:inline-block;
                width: 12%;
                text-align: center;
            }

            div:nth-child(2) {
                width:35%;
            }

            div:nth-child(3) {
                width:40%;
            }

            div.icon {
                font-size: 16px;
                font: normal normal normal 24px/1 "Material Design Icons";
                vertical-align:-15%;
            }

            div.del::after {
                content:"\F01B4";
                cursor:pointer;
            }

            div.jumpoff::after {
                content:"\F0E1E";
            }
        }

        > div {            
            background-color: #222;
            color: #fff; 
        }

        
        > div.head {            
            background-color: #000;
            color: $seltec_color;
            font-weight: bold;
            > div {
                overflow: hidden;
            }
        }

        > div.zebra {
            background-color: #444;
            color: #fff;
        }
    }   

    .field {
        height:$height_mid;
        border: solid 1px $sec_color_dark;
        cursor: pointer;
        text-align: center;
        line-height: $height_mid;
        color:$seltec_color;
        font-size: $height_default;
        font-weight: bold;
        justify-content: center;
    }

    a{
        text-decoration: none;
    }

    a:visited .field {
        border-color: $prim_success_color;
    }

    .input {
        padding-bottom: 10px;
        
        > div {
            width:25%;
        }

        > div:first-of-type {
            width: 75%;
        }
         .f-row, .button {
            justify-content: center;
            div {
                border: solid 1px #818181;
                cursor: pointer;
                min-height: $height_high;
                min-width: $height_high;
                font-weight: bold;
                background-color: #000;
                box-sizing: border-box;
                display: flex;
                flex-grow: 1;
                justify-content: center;
                align-items: center;
            }

            .zero {
                max-width: 33%;;
            }
        }

        .disabled {
            opacity: 0.5;
        }

        .return::after {
            font: normal normal normal 24px/1 "Material Design Icons";
            content: "\F0311";
            color: $font-light-color;
            line-height: ($height_high * 2 - 2px);
        }

        .del::before {
            vertical-align: -15%;
            font: normal normal normal 24px/1 "Material Design Icons";
            content:"\F0B5C";
        }
    }

    .button:active, .buttons div:active {
        background-color: $sec_color_dark;
    }

    .height, .from-height, .interval {
        position: relative;
    }

    .height::before, .from-height::before, .interval::before {
        font: normal normal normal 24px/1 "Material Design Icons";
        color: $sec_bg_color;
        font-size:30px;
        line-height:$height_mid;
        position: absolute;
        padding-left: 10px;  
        height:$height_mid;

    }

    .height::before {          
        content:"\F0795";
    }

    .from-height::before {
        content:"\F0799";
    }

    .interval::before {
        content:"\F084D";
    }

    a:focus {
        outline:none;
        .field::after {
            content:"|"; 
            position: relative;
            margin-right: -11px;
            top: -4px;
            
            animation: blink 1.3s linear infinite;
        }
    }

    .footer-button-row { 
        display: flex;
        justify-content: flex-end;
        padding-top:10px;
        button {
            margin-left: 10px;
        }
    }

    @keyframes blink {
        0% { opacity: 1; }
        50% { opacity: 1; }
        50.01% { opacity: 0; }
        100% { opacity: 0; }
    }

    @media screen and (max-width: $body_max_width) {       
        .content {
            max-height: calc(100vh - 110px);
            height: calc(100vh - 110px);
        }

        .footer-button-row {
            padding-right: 10px;
        }
    }


</style>